/* eslint-disable @angular-eslint/directive-class-suffix */
/* tslint:disable */
import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, Validator } from '@angular/forms';
import { UserService } from '@api/services/user/user.service';
import { Observable } from 'rxjs';
import { debounceTime, first } from 'rxjs/operators';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[email-verifier]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => EmailVerifier),
			multi: true,
		},
	],
	standalone: false,
})
export class EmailVerifier implements Validator {
	validate(c: AbstractControl): Observable<{ [key: string]: any }> {
		return this.verifyUserNameObservable(c.value).pipe(debounceTime(500), first());
	}

	@Input('email-verifier') currentEmail: string = '';
	@Input('email-check-type') type = '';
	constructor(private _userService: UserService) {}

	verifyUserNameObservable(email: string) {
		const emailTest = email.match(
			/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i
		);
		if (emailTest && emailTest[0] !== email) {
			return new Observable((observer) => {
				observer.next(null);
			});
		}
		// set the current user name
		if (this.currentEmail !== '') {
			if (email.trim() === this.currentEmail) {
				return new Observable((observer) => {
					observer.next(null);
				});
			}
		}

		return new Observable((observer) => {
			if (!email) {
				observer.next(null);
			} else {
				this._userService.isEmailValid(email).subscribe(
					(data) => {
						if (data.statusCode === 'FAIL') {
							observer.next({
								'email-verifier': {
									message: 'current email is exsist',
								},
							});
						} else {
							if (this.type === '') {
								observer.next(null);
							} else {
								observer.next({
									'email-verifier-not-exist': {
										message: 'current email is not  exist',
									},
								});
							}
						}
					},
					(err) => {
						// it 's mean the email not exsist and it 's return 404
						if (err.status === 404 && this.type === '') {
							observer.next(null);
						} else {
							observer.next({
								'email-verifier-not-exist': {
									message: 'current email is not  exist',
								},
							});
						}
					}
				);
			}
		});
	}
}
